import { marketDate } from "./upcoming-earnings-data-source.js";

export function calendarDateRange(tab = "upcoming", now = new Date()) {
  const today = marketDate(now);
  const shifted = (days) => new Date(Date.parse(`${today}T00:00:00Z`) + days * 86_400_000).toISOString().slice(0, 10);
  return tab === "recent" ? { from: shifted(-29), to: today } : { from: today, to: shifted(29) };
}
